const u = (id) => `https://images.unsplash.com/${id}?w=600&q=75`;

export const CATS = [
  { slug: "mobiles", name: "Mobiles", image: u("photo-1650580809796-39361e4d77f6") },
  { slug: "electronics", name: "Electronics", image: u("photo-1615655406736-b37c4fabf923") },
  { slug: "appliances", name: "TVs & Appliances", image: u("photo-1567690187548-f07b1d7bf5a9") },
  { slug: "fashion", name: "Fashion", image: u("photo-1569605187723-fcd3c14aef05") },
  { slug: "beauty", name: "Beauty", image: u("photo-1631730486572-226d1f595b68") },
  { slug: "home", name: "Home & Furniture", image: u("photo-1704697475935-46009ec1d1e7") },
  { slug: "grocery", name: "Grocery", image: u("photo-1542838132-92c53300491e") },
  { slug: "toys", name: "Toys & Baby", image: u("photo-1556012018-50c5c0da73bf") },
  { slug: "sports", name: "Sports & Fitness", image: u("photo-1638536532686-d610adfc8e5c") },
  { slug: "books", name: "Books", image: u("photo-1497633762265-9d179a990aa6") },
];

export const SUBS = {
  mobiles: ["5G Phones", "Budget Phones", "Flagship", "Tablets", "Accessories"],
  electronics: ["Audio", "Laptops", "Cameras", "Gaming", "Accessories"],
  appliances: ["Televisions", "Kitchen Appliances", "Washing Machines", "Air Conditioners"],
  fashion: ["Men", "Women", "Footwear", "Watches", "Bags"],
  beauty: ["Skincare", "Makeup", "Body Care", "Fragrance", "Haircare"],
  home: ["Furniture", "Lighting", "Decor", "Kitchen & Dining"],
  grocery: ["Fruits & Vegetables", "Dairy & Eggs", "Spices & Masala", "Honey & Spreads", "Snacks", "Staples"],
  toys: ["Soft Toys", "Learning Toys", "Baby Care", "Outdoor Play"],
  sports: ["Gym & Fitness", "Cricket", "Yoga", "Outdoor"],
  books: ["Fiction", "Exam Prep", "Kids", "Self-Help", "Classics"],
};

export const subLink = (slug, sub) => `/category/${slug}${sub ? `?sub=${encodeURIComponent(sub)}` : ""}`;

export const catName = (slug) => CATS.find((c) => c.slug === slug)?.name || "All";

export const insideOk = (cat, sub) => ["home", "appliances"].includes(cat) || ["Bags", "Kitchen & Dining", "Kitchen Appliances"].includes(sub || "");

const NO_3D_SUBS = /accessor|stationery|office|health|medical|pharma|medicine|detergent|cleaning|dishwash|garbage|household|consumable|baby care/i;
export const no3d = (cat, sub) => ["grocery", "beauty", "books"].includes(cat) || NO_3D_SUBS.test(sub || "");
